import { Component, OnInit } from '@angular/core';
import { CompanyService } from '../../service/company/company.service';
import { Company } from '../../class/company';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public companies: Company[];
    public selectCompany: Company;
    public companyID: Number = 0;
    public modNew = false;
    public modView = false;
    public openCompany = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public companyService: CompanyService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        //this.getCompanies();
    }

    public loadCompaniesLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getCompanies(event.globalFilter);
    }

    public getCompanies(query?: string) {
        this.companyService.getCompany(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.companies = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newCompany() {
        this.modNew = !this.modNew;
        this.selectCompany = null;
    }

    public savedCompany(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectCompany = null;
        this.modNew = false;
        this.getCompanies();
    }

    public cancelCompany (res) {
        this.selectCompany = null;
        this.modNew = false;
        this.modView = false;
        this.getCompanies();
    }

    public edit(company: Company) {
        this.modNew = true;
        this.selectCompany = company;
        this.getCompanies();
    }

    public view(company: Company) {
        this.openCompany = true;
        this.selectCompany = company;
        this.companyID = company.id;
        this.modView = true;
    }

    public deleteDialog(company: Company) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(company);
            }
        });
    }

    public delete(company: Company) {
        this.companyService.deleteCompany(company.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getCompanies();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeCompany(company: Company) {
        this.putCompany(company);
    }

    public putCompany(values: Company) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.companyService.updateCompany(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/companies/companies.component.ts